import { ShippingLabelTypes, ShippingPortalManifest, ShippingPortalParcel } from '@lanterds/types';

export interface ShippingPortalDataItem extends ShippingPortalManifest, ShippingPortalParcel {
    subRows?: ShippingPortalDataItem[];
    originString: string;
    destinationString: string;
    rowId: string;
}

export type ParcelMap = {
    [manifestId: string]: ShippingPortalDataItem[];
};

export type SelectedRows = {
    [rowId: string]: boolean;
};

export const enum OutboundTabs {
    ScheduleAShipment = 0,
    Favorites = 1,
}

// TODO: Move to types when we move the context type
export type SearchTypes = ShippingLabelTypes | 'shipmentTracking' | 'osdReport';

export const enum LocationTypes {
    Origin = 'origin',
    Destination = 'destination',
}
